import { isAndroid, isIOS } from 'react-device-detect';
import { SpaceMembershipReferrer } from '../API';

export const isEmbeddedInSmorgCompanion = () =>
  navigator.userAgent.match(/SmorgCompanion/i);

export const spaceMembershipDefaultReferrer = () => {
  if (!isEmbeddedInSmorgCompanion()) {
    return SpaceMembershipReferrer.END_USER_VIA_WEB_APP;
  }
  if (isAndroid) {
    return SpaceMembershipReferrer.END_USER_VIA_ANDROID_APP;
  }
  if (isIOS) {
    return SpaceMembershipReferrer.END_USER_VIA_IOS_APP;
  }
  console.warn('Unknown mobile device?');
  return null;
};

export const postMessageToSmorgCompanion = (messageDataObj) => {
  if (!window.ReactNativeWebView) {
    console.warn('ReactNativeWebView not available');
    return;
  }
  window.ReactNativeWebView.postMessage(JSON.stringify(messageDataObj));
};
